<template>
  <div>
    <div class="max-w-xl p-6 mx-auto space-y-6">
      <div class="max-w-lg mx-auto text-sm text-center text-gray-500">
        You may review your order <span class="hidden lg:inline">in the summary to the right of your screen</span><span class="lg:hidden">by tapping the Show Summary drawer at the bottom of your screen</span> or click the Confirm button to place your order.
      </div>
      
      <fieldset v-if="options.require_confirmation" ref="confirmation">
        <div class="leading-tight bg-white border rounded" :class="{ 'border-gray-500 ring-4 ring-gray-300': !form.confirmed }"> 
          <label class="flex p-4">
            <input type="checkbox" class="mr-4 transform scale-125 translate-y-px text-accent form-checkbox" v-model="form.confirmed"> 
            <div class="form-label">
              {{ options.confirmation_text }}
            </div>
          </label>
          <div class="flex py-2 pl-12 text-sm leading-none bg-gray-100 rounded-b">
            <div v-if="options.legal_terms">
              <a :href="options.legal_terms" target="_blank" rel="noopener nofolower noreferrer" class="text-gray-600">
                Terms &amp; Conditions
              </a>
            </div>
            <div v-if="options.legal_privacy && options.legal_terms" class="w-px h-4 mx-3 bg-gray-300"></div>
            <div v-if="options.legal_privacy">
              <a :href="options.legal_privacy" target="_blank" rel="noopener nofolower noreferrer" class="text-gray-600">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
        <validations :errors="errors" field="confirmed" v-show="submitted" />
      </fieldset>
    </div>

    <BookBottomBar>
      <template slot="back">
        <button class="w-full btn btn-outline" @click="$parent.back()">
          <fa :icon="['far', 'chevron-left']" class="mr-2 text-sm" /> Back
        </button>
      </template>
      <template slot="next">
        <button 
          class="w-full btn btn-accent" 
          :class="{ 'opacity-75 cursor-not-allowed': options.require_confirmation && !form.confirmed }" 
          v-submitting="$parent.submitting" 
          @click="submit()">
          Confirm <fa :icon="['far', 'check']" class="ml-2 text-sm" />
        </button>
      </template>
    </BookBottomBar>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import BookBottomBar from './BookBottomBar'
  
  export default {
    name: 'BookConfirm',

    components: {
      BookBottomBar
    },

    computed: {
      ...mapState('booking', ['options']),
      ...mapFields('booking', ['form']),

      errors () {
        let array = []
        if (this.options.require_confirmation) {
          if (!this.form.confirmed) {
            array.push({ 
              field: 'confirmed', 
              rule: 'required', 
              message: 'Please check the box to confirm your order.' 
            })
          }
        }
        return array
      }
    },

    data () {
      return {
        submitted: false
      }
    },

    methods: {
      submit () {
        this.submitted = true
        if (!this.errors.length) {
          this.$parent.submit()
        } else {
          this.$nextTick(() => {
            document.querySelector('.form-error').scrollIntoView({ 
              behavior: 'smooth', block: 'start', inline: 'nearest' 
            })
          })
          this.$toasted.error('Please check the confirmation box.')
        }
      }
    }
  }
</script>